import { CommonBaseData } from "../data/common-base-data";

export class IzonmojiModel extends CommonBaseData {
  // 入力値
  public inputValue: string;
  // チェック結果
  public returnValue: boolean;
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/data/izonmoji-model.ts